import {
  OneOfElements,
  OneOfPropertyElements,
} from '@shared/models/project.model';
import { isOneOfPropertyElements } from '../../recursive-element.helpers';
import { getElementProperties } from '../../element-property.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type PropertyRemoveChange =
  ProjectChangeMap[ProjectChangeType.ElementPropertyRemove];

/**
 * Remove properties from an element by their IDs.
 * The caller is responsible for including related property IDs
 * (e.g. data-table siblings) in {@link PropertyRemoveChange.propertyIds}.
 *
 * @param element - Current element state
 * @param change - Payload with property IDs to remove
 * @returns Partial with filtered properties array, or undefined when element has no properties
 */
export const elementPropertyRemoveToChange = (
  element: OneOfElements,
  change: PropertyRemoveChange,
): Partial<OneOfPropertyElements> | undefined => {
  if (!isOneOfPropertyElements(element)) return undefined;

  const properties = getElementProperties(element).filter(
    (p) => !change.propertyIds.includes(p.id),
  );

  return { properties };
};
